import gtag from '../analytics/gtag';
import FormGroup from '../generic/forms/FormGroup';
import InputGroup from '../generic/forms/InputGroup';
import SubmitButton from '../generic/forms/SubmitButton';
import type { Facet } from '../model/Facets';
import preventDefault from '../utils/preventDefault';
import { useAsyncAction } from '../utils/useAsyncAction';
import { withFormData } from '../utils/withFormData';
import * as style from './PriceRangeFacet.module.css';

interface FacetProps {
    facet: Facet;
    onFacetValueSelect(query: string): Promise<void> | void;
}

const integerRegex = /^-?\d*$/;

export default function PriceRangeFacet({ facet, onFacetValueSelect }: FacetProps) {
    const [onSubmit, isLoading, error, , reset] = useAsyncAction(async ({ from, to, query }: Record<string, string>) => {
        if (!from && !to) {
            throw 'Du må fylle inn minst ett av feltene.';
        }

        if (!integerRegex.test(from) || !integerRegex.test(to)) {
            throw 'Du må fylle inn tall.';
        }

        const f = from ? Number(from) : 0;
        const t = to ? Number(to) : Infinity;

        if (isNaN(f) || isNaN(t)) {
            throw 'Du må fylle inn tall.';
        }

        if (f < 0 || t < 0) {
            throw 'Prisene kan ikke være negative.';
        }

        if (t < f) {
            throw 'Fra kan ikke være større enn til.';
        }

        const value = query.replace('(TO)', `(${from}TO${to})`);
        await onFacetValueSelect(value);
        gtag('event', 'filter', {
            filter_type: facet.name,
            filter_value: value,
        });
    });
    return (
        <form className={style.priceRangeFacet} onSubmit={preventDefault(withFormData(onSubmit))}>
            <input type="hidden" name="query" value={facet.values[0].query} />
            <InputGroup name="from" label="Fra" inputMode="numeric" maxLength={6} aria-invalid={!!error} onChange={reset} />
            <InputGroup name="to" label="Til" inputMode="numeric" maxLength={6} aria-invalid={!!error} onChange={reset} />
            <FormGroup id="" label=" ">
                <SubmitButton className="btn-secondary" isLoading={isLoading}>
                    Søk
                </SubmitButton>
            </FormGroup>
            <div className="error">{error?.toString()}</div>
        </form>
    );
}
